// 只改写 JSON 数字 token，不触碰引号中的数字、图片路径或转义字符。
const tokens = /"(?:[^"\\]|\\.)*"|-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?|true|false|null|[{}[\],:]/g;

export function parseJsonPreservingIntegers(text) {
  if (typeof text !== 'string') throw new TypeError('JSON must be text');
  JSON.parse(text);
  const safeText = text.replace(tokens, token => {
    if (/^-?\d+$/.test(token) && !Number.isSafeInteger(Number(token))) return JSON.stringify(token);
    return token;
  });
  return JSON.parse(safeText);
}

// 格式化保留原始 token；大整数和种子不会被转换为字符串或舍入。
export function formatJsonPreservingValues(text) {
  JSON.parse(text);
  const parts = text.match(tokens) || [];
  let result = '';
  let depth = 0;
  const newline = () => { result += '\n' + '  '.repeat(depth); };
  parts.forEach((token, index) => {
    if (token === '{' || token === '[') {
      result += token;
      depth++;
      if (parts[index + 1] !== (token === '{' ? '}' : ']')) newline();
    } else if (token === '}' || token === ']') {
      depth--;
      if (parts[index - 1] !== (token === '}' ? '{' : '[')) newline();
      result += token;
    } else if (token === ',') {
      result += ',';
      newline();
    } else if (token === ':') {
      result += ': ';
    } else {
      result += token;
    }
  });
  return result;
}

// For read-back checks only. Preserve number token types and exact digits; object
// key order/formatting may change, but string contents and array order must not.
export function jsonContentSignature(text) {
  if (typeof text !== 'string') throw new TypeError('JSON must be text');
  const parsed = JSON.parse(text);
  const strings = JSON.stringify(parsed);
  let marker = '__kerqu_number_0__';
  for (let index = 1; strings.includes(marker); index++) marker = `__kerqu_number_${index}__`;
  const tagged = JSON.parse(text.replace(tokens, token => /^-?\d/.test(token) ? JSON.stringify(marker + token) : token));
  const canonical = value => {
    if (Array.isArray(value)) return ['array', value.map(canonical)];
    if (value && typeof value === 'object') return ['object', Object.keys(value).sort().map(key => [key, canonical(value[key])])];
    if (typeof value === 'string' && value.startsWith(marker)) return ['number', value.slice(marker.length)];
    return [value === null ? 'null' : typeof value, value];
  };
  return JSON.stringify(canonical(tagged));
}

// 阅读/复制所用的紧凑 JSON 只去除 token 之间的空白，不重新序列化数字。
export function compactJsonPreservingValues(text) {
  JSON.parse(text);
  return (text.match(tokens) || []).join('');
}

// 折叠树以 bigint 保留超出安全范围的整数，避免将原数字误显示成字符串。
export function parseJsonForDisplay(text) {
  const parsed = JSON.parse(text);
  const strings = JSON.stringify(parsed);
  let marker = '__kerqu_display_integer__';
  while (strings.includes(marker)) marker += '_';
  const tagged = text.replace(tokens, token => /^-?\d+$/.test(token) && !Number.isSafeInteger(Number(token))
    ? JSON.stringify(marker + token) : token);
  return JSON.parse(tagged, (_, value) => typeof value === 'string' && value.startsWith(marker)
    ? BigInt(value.slice(marker.length)) : value);
}
